import React, { PureComponent } from 'react';
import COLORS from 'constants/colors';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link, withRouter } from 'react-router-dom';
import { FlexView } from '@cuemath/comps';
import Popup from 'reactjs-popup';

import { tabs } from 'constants/left-nav';
import { MenuText, MenuWrapper, MenuCol } from 'comps';
import { tabs as leftNavTabs, MORE_OPTIONS, TABS } from 'constants/left-nav';
import TeacherAvatar from '../teacher-avatar/teacher-avatar';
import MasterTemplate from '../master-template';

import cuemathLogo from 'img/left-nav/cuemath-symbol.svg';
import starBurst from 'img/left-nav/star-burst.svg';
import Logout from 'modules/logout';
import { stringify } from 'query-string';
import { connect } from 'react-redux';

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 72px;
  right: 0;
  height: 100%;
  padding-top: 16px;
  z-index: ${({ hideHeaderWhenModalOpen }) => (hideHeaderWhenModalOpen ? 10 : 13)};
  background-color: ${COLORS.COLA};
`;

const BottomContainer = styled.div`
  bottom: 30px;
  position: absolute;
  .popup-overlay {
    z-index: 2;
  }
`;

const WrapperCol = styled(FlexView)`
  align-items: center;
  flex-direction: column;
`;

const Logo = styled.img`
  display: block;
  width: 30px;
  height: 30px;
`;

const StarIcon = styled.img`
  position: absolute;
  bottom: 0;
  z-index: -1;
  transform: translate(0, 66%);
`;

const StyledRow = styled(FlexView)`
  width: 68px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-left: 4px solid ${({ selected }) => (selected ? COLORS.WHITE : 'transparent')};
  border-right: 4px solid transparent;
  cursor: pointer;
`;

const Overlay = styled.div`
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  width: 40px;
  height: 40px;
  z-index: -1;
  border-radius: 8px;
`;

const IconWrapper = styled(FlexView)`
  position: relative;
`;

export const NotificationsIcon = styled.img`
  width: 24px;
  height: 24px;
  text-align: right;
`;

const customStyle = {
  position: 'absolute',
  padding: '8px 0px',
  borderRadius: 8,
  boxShadow: '0px 2px 16px rgba(0, 0, 0, 0.15)',
  border: `1px solid ${COLORS.GHOST}`,
  background: 'white',
};

const { MORE, LOGOUT } = leftNavTabs;

class AppHeader extends PureComponent {
  static propTypes = {
    classStatus: PropTypes.shape({}),
    schoolPerformance: PropTypes.shape({}),
    schoolPerformanceGK: PropTypes.bool,
    userId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    classStatus: null,
    schoolPerformance: {},
    schoolPerformanceGK: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeTab: null,
      hoveredTab: null,
      supportTabSelected: false,
      profileTabSelected: false,
      notificationTabSelected: false,
    };

    this.profileRef = React.createRef(null);
  }

  handleProfileClick = (val, showVacancyList) => {
    const { profileTabSelected } = this.state;

    if (val === 'close' && !showVacancyList) {
      this.setState({
        profileTabSelected: false,
      });
    } else if (val) {
      this.setState({
        profileTabSelected: true,
      });
    } else {
      this.setState({
        notificationTabSelected: false,
        profileTabSelected: !profileTabSelected,
      });
    }
  };

  componentDidUpdate(prevProps) {
    const { history: { location: prevLocation } = {} } = prevProps;
    const { history: { location } = {} } = this.props;
    const { prevPathname } = prevLocation || {};
    const { pathname } = location || {};

    if (stringify(prevPathname) !== stringify(pathname)) {
      const currentItem = TABS.filter(item => {
        let match = null;

        if (item.startsWith) {
          item.startsWith.forEach(sw => {
            if (pathname.startsWith(sw)) match = true;
          });
        }
        return item.link === pathname || match;
      });

      const leadsItem = MORE_OPTIONS.filter(
        item => item.link === pathname || pathname.startsWith(item.startsWith),
      );

      if (currentItem.length) {
        const [{ id }] = currentItem;

        this.setState({
          activeTab: id,
        });
      }
      if (leadsItem.length) {
        this.setState({
          activeTab: MORE,
        });
      }
      if (!currentItem.length && !leadsItem.length) {
        this.setState({
          activeTab: null,
        });
      }
    }
  }

  changeActiveTab = tabId => {
    const { activeTab, notificationTabSelected } = this.state;

    if (activeTab === tabId) return;
    if (notificationTabSelected) return;

    this.setState({
      activeTab: tabId,
    });
  };

  changeHoveredTab = (tabId, enter) => {
    this.setState({
      hoveredTab: enter ? tabId : null,
    });
  };

  closePopup = () => {
    if (this.profileRef.current) {
      this.profileRef.current.closePopup();
    }
  };

  renderTriggerComp = () => {
    const { PROFILE } = tabs;
    const { hoveredTab } = this.state;
    const profileHovered = hoveredTab === PROFILE;

    return (
      <div>
        <StyledRow
          onMouseEnter={() => this.changeHoveredTab(PROFILE, true)}
          onMouseLeave={() => this.changeHoveredTab(PROFILE, false)}
        >
          {profileHovered && <Overlay />}
          <IconWrapper onClick={this.handleProfileClick}>
            <TeacherAvatar enableTeacherRevamp={true} selected={false} gender="male" />
          </IconWrapper>
        </StyledRow>
      </div>
    );
  };

  render() {
    const { activeTab, hoveredTab } = this.state;
    const { maintenance } = this.props;
    const { underMaintenance } = maintenance || {};

    return (
      <Header hideHeaderWhenModalOpen={underMaintenance}>
        <WrapperCol>
          <Link to="/" onClick={this.changeActiveTab}>
            <Logo src={cuemathLogo} alt="cuemath logo" />
          </Link>
          <React.Fragment>
            <MasterTemplate
              activeTab={activeTab}
              changeGlobalActiveTab={this.changeActiveTab}
              handleCloseNotifPanel={this.handleCloseNotifPanel}
            />
            <BottomContainer>
              <Popup
                ref={this.profileRef}
                trigger={this.renderTriggerComp}
                onClose={this.closePopup}
                offsetY={10}
                offsetX={10}
                position="right bottom"
                on="click"
                closeOnDocumentClick
                contentStyle={customStyle}
                arrow={false}
              >
                <FlexView>
                  <MenuWrapper
                    key={LOGOUT}
                    onMouseEnter={() => this.changeHoveredTab(LOGOUT, true)}
                    onMouseLeave={() => this.changeHoveredTab(LOGOUT, false)}
                    hovered={hoveredTab === LOGOUT}
                    onClick={this.closePopup}
                  >
                    <MenuCol>
                      <MenuText>
                        <Logout />
                      </MenuText>
                    </MenuCol>
                  </MenuWrapper>
                </FlexView>
              </Popup>
              <StarIcon src={starBurst} width={72} height={72} alt="starBurst" />
            </BottomContainer>
          </React.Fragment>
        </WrapperCol>
      </Header>
    );
  }
}

export default withRouter(connect(({ maintenance }) => ({ maintenance }))(AppHeader));
